export default __webpack_public_path__ + "static/media/Whitepaper.37b0e0a1.png";